<template>
    <div
        style="overflow-wrap: anywhere"
    >
        <div
            v-html="$options.filters.nl2br(attachmentToLink(visibleText))"
        />
        <div
            v-if="hasHiddenFragments"
            class="mt-2 hidden-button"
        >
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <icon-button
                        :on="on"
                        icon="MoreHorizontal"
                        @click="showHidden = !showHidden"
                    />
                </template>
                {{ messageExpandCollapseText }}
            </v-tooltip>
        </div>
        <div v-if="showHidden">
            <div
                v-for="(fragment, index) of parsedFragments"
                :key="index"
                class="d-flex my-1"
            >
                <v-divider
                    v-if="index !== 0"
                    vertical
                    :style="`margin-left: ${(index * 8)}px`"
                    class="mr-2"
                />
                <div
                    v-html="$options.filters.nl2br(attachmentToLink(fragment.getContent()))"
                />
            </div>
        </div>
        <div v-if="item.files && item.files.length" class="attachments mt-2 d-flex flex-wrap mb-n2">
            <MiniAttachmentChip
                v-for="file in item.files"
                :key="file.id"
                :file="file"
                @click="$emit('download', $event)"
            />
        </div>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import {computed, ref, watch} from "@vue/composition-api";
import {QUOTE_HEADERS_REGEX, QUOTE_REGEX, SIGNATURE_REGEX, TASK_LOG_TYPE} from "@/helpers/constants";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import MiniAttachmentChip from "@/components/MiniAttachmentChip.vue";
import {downloadFile} from "@/helpers/helpers";
import Parser from "node-email-reply-parser/lib/Parser"

export default {
    name: "EmailBody",
    components: {
        MiniAttachmentChip
    },
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    setup(props, ctx) {
        const showHidden = ref(false);

        const attachmentToLink = (str) => {
            return str.replace(/\[File:\d+\|[^\]]+\]/gm, function (m) {
                let arr = m.substr(6, m.length - 7).split("|");
                return '<a href="/api/task_attachment/{0}">{1}</a>'.format(arr[0], arr[1]);
            });
        }

        const download = async (file) => {
            try {
                await downloadFile('task_attachment', file)
            } catch (e) {
                errorDialog.showError(e)
            }
        }

        const parsedMessage = computed(() => {
            const parser = new Parser(SIGNATURE_REGEX, QUOTE_REGEX, QUOTE_HEADERS_REGEX)

            return parser.parse(props.item.message)
        })

        const parsedFragments = computed(() => {
            const allFragments = parsedMessage.value.getFragments()
            return allFragments.slice(1)
        })

        const visibleText = computed(() => {
            return parsedMessage.value.getVisibleText()
        })

        const hasHiddenFragments = computed(() => {
            for (const fragment of parsedFragments.value) {
                if (fragment.isHidden()) {
                    return true
                }
            }

            return false
        })

        const messageExpandCollapseText = computed(() => {
            if (showHidden.value) {
                return $t('Hide expanded content')
            } else {
                return $t('Show trimmed content')
            }
        })

        return {
            attachmentToLink,
            TASK_LOG_TYPE,
            download,
            parsedFragments,
            visibleText,
            showHidden,
            hasHiddenFragments,
            messageExpandCollapseText,
        }
    }
}
</script>

<style scoped>
.hidden-button ::v-deep {
    .v-btn {
        height: 24px !important;
    }
}
</style>